/**
 * @module app.cm
 */

﻿import * as CM from 'app/cm/models/essette-api';
import * as CD from 'app/cd/models/essette-api';

export class FilterDiagnosesValueConverter {

    public toView(searchDiagnoses: CD.Diagnosis[], memberDiagnoses: CM.MemberDiagnosis[]): CD.Diagnosis[] {
        const currentDiagnosisIds = memberDiagnoses.filter(d => !d.isActive).map(diag => { return diag.diagnosis && diag.diagnosis.id || null; });

        return searchDiagnoses.filter(diag => currentDiagnosisIds.includes(diag.id || null));
    }

}
